import { CONFIG } from '../core/config.mjs';

/**
 * Normalise URL image pour le JavaScript côté client (utilise l'ancienne structure /img)
 */
export function normalizeImageSrc(src) {
    const baseUrl = window.location.protocol + '//' + window.location.host;
    const imgEndpoint = '/img'; // Utiliser l'ancienne structure pour le JavaScript

    if (src.startsWith('http')) {
        const currentUrlObj = new URL(window.location.href);
        const srcUrlObj = new URL(src);

        if (srcUrlObj.hostname === currentUrlObj.hostname) {
            // Image locale - endpoint relatif
            const relativePath = srcUrlObj.pathname + srcUrlObj.search;
            return `${imgEndpoint}?image=${encodeURIComponent(relativePath)}`;
        }
        // Image externe
        return `${imgEndpoint}?image=${encodeURIComponent(src)}`;
    }

    // URL relative
    let fullPath = src;
    if (!src.startsWith('/')) {
        fullPath = '/' + src;
    }

    return `${imgEndpoint}?image=${encodeURIComponent(fullPath)}`;
}

/**
 * Détecte si URL pointe vers PNG
 */
export function isPngImage(src) {
    const lowerSrc = src.toLowerCase();
    return lowerSrc.endsWith('.png') ||
        lowerSrc.includes('.png?') ||
        lowerSrc.includes('format=png');
}
